export default {
  strings: 6,
  fretsOnChord: 4,
  name: 'guitar'
};